var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaneGreen = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 19,
  viewBox: "0 0 22 19",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "rhjh7b441b",
  x1: "55.112%",
  x2: "50%",
  y1: "33.082%",
  y2: "70.577%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B4ECDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1ED6AC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3yc2bqta7d",
  x1: "53.942%",
  x2: "22.045%",
  y1: "8.89%",
  y2: "76.04%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B4ECDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "11.774%",
  stopColor: "#ADEBDD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0CC59C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pf9li8nnre",
  x1: "53.333%",
  x2: "50%",
  y1: "8.89%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#02372B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1ED6AC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "xuqryhmykg",
  x1: "52.657%",
  x2: "50%",
  y1: "8.89%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B4ECDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1ED6AC"
})), /*#__PURE__*/React.createElement("path", {
  id: "1fs1yzxjga",
  d: "M0 0.019L20.829 0.019 20.829 13.381 0 13.381z"
}), /*#__PURE__*/React.createElement("path", {
  id: "5w6euip8uf",
  d: "M0.001 0.021L12.421 0.021 12.421 17.248 0.001 17.248z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-36 -315) translate(36 315) translate(0 .08)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "iskqfhqw4c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#1fs1yzxjga"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rhjh7b441b)",
  d: "M20.642.034L.417 10.248c-.596.3-.541 1.17.088 1.392l4.873 1.727c.088.03.185.012.256-.048L20.784.246c.114-.1-.007-.28-.142-.212",
  mask: "url(#iskqfhqw4c)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#3yc2bqta7d)",
  d: "M6.233 17.455c.072.397.578.526.83.212L20.96.409c.067-.085-.046-.195-.128-.124l-15.2 13.117c-.07.059-.101.15-.085.239l.687 3.814z",
  transform: "translate(-36 -315) translate(36 315)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "url(#pf9li8nnre)",
  transform: "translate(-36 -315) translate(36 315) translate(6.686 1.877)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.098 15.823l1.424-2.992c.323-.68.747-1.308 1.256-1.863L12.755.093c.088-.097.236.03.154.132L.266 15.93c-.074.092-.22 0-.168-.106"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-36 -315) translate(36 315) translate(8.981 .28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rekuqdf6zh",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5w6euip8uf"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#xuqryhmykg)",
  d: "M.253 13.635l8.222 3.547c.474.205 1.016-.088 1.105-.597L12.416.373c.051-.295-.314-.475-.516-.254L.111 12.969c-.194.212-.121.552.142.666",
  mask: "url(#rekuqdf6zh)"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaneGreen);
export default ForwardRef;